// Real Facebook Pixel integration.
// Loads the actual Meta pixel script using the Pixel ID saved in Admin → Meta settings,
// then exposes typed helper functions that fire the standard e-commerce events.
//
// Events fired automatically by the app once initialized:
//   PageView          - every route change (handled by PixelRouteTracker)
//   ViewContent       - product detail page open
//   AddToCart         - item added to cart
//   InitiateCheckout  - checkout page reached
//   Purchase          - order placed successfully

let pixelId = null;
let initialized = false;

const loadPixelScript = (id) => {
  if (typeof window === 'undefined') return;
  if (window.fbq) { window.fbq('init', id); return; }

  // Standard Meta Pixel base code, injected programmatically.
  /* eslint-disable */
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = '2.0';
    n.queue = [];
    t = b.createElement(e); t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', id);
};

/**
 * Call once, as early as possible (e.g. when Meta settings load), with the Pixel ID
 * from Admin → Meta. Safe to call multiple times — only initializes once per ID.
 */
export const initPixel = (id) => {
  if (!id || initialized && id === pixelId) return;
  pixelId = id;
  loadPixelScript(id);
  initialized = true;
};

export const isPixelReady = () => initialized && !!window.fbq;

const fire = (eventName, params) => {
  if (!isPixelReady()) return;
  try {
    window.fbq('track', eventName, params);
  } catch (e) {
    console.warn('Pixel event failed:', eventName, e);
  }
};

export const trackPageView = () => fire('PageView');

export const trackViewContent = (product) => {
  if (!product) return;
  fire('ViewContent', {
    content_ids: [product.id],
    content_name: product.title,
    content_type: 'product',
    value: product.salePrice && product.salePrice < product.price ? product.salePrice : product.price,
    currency: 'PKR',
  });
};

export const trackAddToCart = (product, quantity = 1) => {
  if (!product) return;
  const price = product.salePrice && product.salePrice < product.price ? product.salePrice : product.price;
  fire('AddToCart', {
    content_ids: [product.id],
    content_name: product.title,
    content_type: 'product',
    value: price * quantity,
    currency: 'PKR',
  });
};

export const trackInitiateCheckout = (items, total) => {
  if (!items?.length) return;
  fire('InitiateCheckout', {
    content_ids: items.map(i => i.id),
    content_type: 'product',
    num_items: items.reduce((s, i) => s + i.quantity, 0),
    value: total,
    currency: 'PKR',
  });
};

export const trackPurchase = (orderId, items, total) => {
  if (!items?.length) return;
  fire('Purchase', {
    content_ids: items.map(i => i.id),
    content_type: 'product',
    num_items: items.reduce((s, i) => s + i.quantity, 0),
    value: total,
    currency: 'PKR',
    order_id: orderId,
  });
};
